import React, { useState, useEffect } from "react";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { Link, useParams } from "react-router-dom";
import Header from "./Header";
import axios from "axios";
import itemImg from "../assets/images/upcoming-collection-artwork-page/artwork-sample-1.png";
import buyerIcon from "../assets/images/user-profile/profile-picture.png";
import image0 from "../assets/images/Artwork-Specific-Edition-Page-Auction/0.png";
import image1 from "../assets/images/Artwork-Specific-Edition-Page-Auction/1.png";
import image2 from "../assets/images/Artwork-Specific-Edition-Page-Auction/2.png";
import image3 from "../assets/images/Artwork-Specific-Edition-Page-Auction/3.png";
import image4 from "../assets/images/Artwork-Specific-Edition-Page-Auction/4.png";
import user1 from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png";
import user2 from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-2.png";
import user3 from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-3.png";
import user4 from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-4.png";
import droppedIcon from "../assets/images/Artwork-Specific-Edition-Page-Auction/dropped-icon.svg";
import purchasedIcon from "../assets/images/Artwork-Specific-Edition-Page-Auction/purchased-icon.svg";
import listedIcon from "../assets/images/Artwork-Specific-Edition-Page-Auction/listed-icon.svg";
import initialDrop from "../assets/images/Artwork-Specific-Edition-Page-Auction/initial-drop-date.svg";
import averageResalePrice from "../assets/images/Artwork-Specific-Edition-Page-Auction/average-resale-price.svg";
import highestBid from "../assets/images/Artwork-Specific-Edition-Page-Auction/highest-bid-all-editions.svg";
import lowestAsk from "../assets/images/Artwork-Specific-Edition-Page-Auction/lowest-ask-all-editions.svg";
import marketplaceSales from "../assets/images/Artwork-Specific-Edition-Page-Auction/marketplace-sales.svg";
import marketplaceVolume from "../assets/images/Artwork-Specific-Edition-Page-Auction/marketplace-volume.svg";
import priceChange from "../assets/images/Artwork-Specific-Edition-Page-Auction/price-change-since-drop.svg";
import purchasePrice from "../assets/images/Artwork-Specific-Edition-Page-Auction/purchase-price-range.svg";
import { getItemData, buy } from "../blockchain/functions/functions";
import Collection from "./Collection";

const SpecificItem = () => {
  let { collection, address, id } = useParams();
  const [itemData, setItemData] = useState({
    isAuction: false,
    price: "0",
    supply: 0,
    currentSupply: 0,
    bids: [],
  });
  const [collectionData, setCollectionData] = useState({
    name: "",
    description: "",
    image: "",
    items: [],
  });

  const handleBuy = async () => {
    let receipt = await buy("1", id, address, itemData.price);
    if (receipt) {
      getData();
      console.log(receipt);
    }
  };

  const getData = async () => {
    if (address) {
      let newData = await getItemData(id, address);
      setItemData(newData);
      console.log(newData);
    }
    if (id) {
    }
  };

  const getCollectionDetails = async () => {
    console.log(collection);
    if (collection) {
      let details = await axios.get(
        `https://nfttest.xyz/nftapi/index.php/home/get_collections/${collection}`
      );

      console.log(details.data);
      setCollectionData(details.data);
    }
  };

  useEffect(() => {
    getCollectionDetails();
    getData();
  }, []);

  return (
    <div className="main-wrapper">
      <Header />
      {/* Header area end */}

      {/* Item details area start */}
      <div className="container mb-3">
        <div className="row collection justify-content-between">
          <div className="col-md-6 upcoming-collection">
            <img
              src={`https://nfttest.xyz/nftapi/${collectionData?.items[id]?.images}`}
              alt=""
              width="100%"
            />
            <p>
              <Link to={`/collection/${collection}`}>VIEW COLLECTION</Link>
              <small className="pull-right">Contract Address</small>
            </p>
            <small className="pull-right">{address}</small>
          </div>

          <div className="col-md-5 mt-auto mb-4    upcoming">
            <h1>
              {collectionData?.items[id]?.item_title}
              <span>
                Owned by <Link to="/UserProfileBuyer">NFTYbuyer1 </Link>
                <img src={buyerIcon} alt="buyer" />
              </span>
            </h1>
            <hr />
            <p>
              {collectionData?.name}
              <span>Edition of {itemData.supply}</span>
            </p>
            <p>
              ITEM DESCRIPTION. Lorem ipsum dolor sit amet, consectetuer
              adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
              laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim
              veniam, quis nostrud exerci tation ullamcorper suscipit lobortis
              nisl ut aliquip ex ea commodo consequat. Duis autem vel
            </p>
            <h2>
              {itemData.price / 10 ** 18} ETH
              <span>{itemData.highBid / 10 ** 18} ETH</span>
            </h2>
            <h5>
              Original Listing
              <span>Highest Bid</span>
            </h5>
            {itemData.isAuction ? (
              <Link to={`/PlaceBid/${collection}/${address}/${id}`}>
                <button type="button">Place a Bid</button>
              </Link>
            ) : (
              <button onClick={() => handleBuy()} type="button">
                Buy
              </button>
            )}

            <h4>{itemData.currentSupply} editions purchased</h4>
          </div>
        </div>
      </div>
      {/* Item details area end */}

      {/* Edition history and stats area start */}
      <div className="container mb-5">
        <div className="row">
          {/* Edition history area start */}
          <div className="col-md-4 history-area">
            <h1>Edition History</h1>
            <div className="row edition-history">
              <div className="image">
                <img src={user3} alt="" />
                <img src={listedIcon} alt="" />
              </div>
              <div className="text">
                <p>Listed for {itemData.price / 10 ** 18}</p>
              </div>
              <div className="time">
                <p>1m ago</p>
              </div>
            </div>
            <div className="row edition-history">
              <div className="image">
                <img src={user4} alt="" />
                <img src={purchasedIcon} alt="" />
                <img src={user3} alt="" />
              </div>
              <div className="text">
                <p>Purchased for $8,000.00</p>
              </div>
              <div className="time">
                <p>1h ago</p>
              </div>
            </div>
            <div className="row edition-history">
              <div className="image">
                <img src={user4} alt="" />
                <img src={listedIcon} alt="" />
              </div>
              <div className="text">
                <p>Listed for $3,333.33</p>
              </div>
              <div className="time">
                <p>15h ago</p>
              </div>
            </div>
            <div className="row edition-history">
              <div className="image">
                <img src={user1} alt="" />
                <img src={purchasedIcon} alt="" />
                <img src={user4} alt="" />
              </div>
              <div className="text">
                <p>Purchased for $6,000.00</p>
              </div>
              <div className="time">
                <p>20d ago</p>
              </div>
            </div>
            <div className="row edition-history">
              <div className="image">
                <img src={user2} alt="" />
                <img src={droppedIcon} alt="" />
                <img src={user1} alt="" />
              </div>
              <div className="text">
                <p>Dropped for $6,000.00</p>
              </div>
              <div className="time">
                <p>Feb 20</p>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <h1 className="stats-heading">Stats</h1>
            <div className="row justify-content-between">
              <div className="col-md-3 stats-area">
                <div className="row justify-content-initial">
                  <div>
                    <img src={initialDrop} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>2/20/21</h4>
                    <p>Initial Drop</p>
                  </div>
                </div>
                <div className="row justify-content-initial">
                  <div>
                    <img src={priceChange} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>+120%</h4>
                    <p>Price Premium</p>
                    <span>(Over Initial drop price)</span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 stats-area">
                <div className="row justify-content-initial">
                  <div>
                    <img src={marketplaceSales} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>200</h4>
                    <p>Marketplace Sales</p>
                  </div>
                </div>
                <div className="row justify-content-initial">
                  <div>
                    <img src={purchasePrice} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>$2k-$30k</h4>
                    <p>Lifespan Range</p>
                    <span>(Low-High For All Transactions)</span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 stats-area">
                <div className="row justify-content-initial">
                  <div>
                    <img src={averageResalePrice} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>$12,345.00</h4>
                    <p>Average Resale Price</p>
                  </div>
                </div>
                <div className="row justify-content-initial">
                  <div>
                    <img src={marketplaceVolume} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>$88,888.88</h4>
                    <p>Marketplace Volume</p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 text-center stats-area">
                <div className="row justify-content-initial">
                  <div>
                    <img src={highestBid} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>$17,000.00</h4>
                    <p>Highest Bid - All Editions</p>
                  </div>
                </div>
                <div className="row justify-content-initial">
                  <div>
                    <img src={lowestAsk} alt="" />
                  </div>
                  <div className="stats-text">
                    <h4>$7,000.00</h4>
                    <p>Lowest Ask - All Editions</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Edition history area end */}
          <Link to={`/collection/${collection}`}>
            <button
              // onClick={() => handleBuy(index, item.price)}
              style={{ width: "120px" }}
              className="buy-button"
            >
              Back to collection
            </button>
          </Link>
        </div>
      </div>
      {/* Edition history and stats area end */}
    </div>
  );
};

export default SpecificItem;
